import { render, staticRenderFns } from "./EditNews.vue?vue&type=template&id=ee9e46e4&scoped=true&"
import script from "./EditNews.vue?vue&type=script&lang=ts&"
export * from "./EditNews.vue?vue&type=script&lang=ts&"
import style0 from "./EditNews.vue?vue&type=style&index=0&id=ee9e46e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee9e46e4",
  null
  
)

export default component.exports